import { Loadable } from 'foundations-components/transitional/utils/Loadable';
export default Loadable({
  loader: () => import( /* webpackChunkName: "unpublish-modal" */'./UnpublishingOptionsModal').then(mod => mod.default),
  LoadingComponent: () => null
});